import { FC, ReactNode } from 'react';
import { cn } from '@fe-learner-common';

type BadgeProps = {
  className?: string;
  children?: ReactNode;
  as?: 'span' | 'div';
  size: 'sm' | 'md' | 'lg';
  type: 'neutral' | 'positive' | 'negative' | 'attention' | 'prominence';
};

const sizeMap = {
  sm: 'lf:w-[8px] lf:h-[8px]',
  md: 'lf:w-[16px] lf:h-[16px]',
  lg: 'lf:w-[20px] lf:h-[20px]',
};

const typeMap = {
  neutral: 'lf:bg-neutral-300 lf:text-neutral-800',
  positive: 'lf:bg-positive-500 lf:text-neutral-0',
  negative: 'lf:bg-negative-500 lf:text-neutral-0',
  attention: 'lf:bg-attention-500 lf:text-neutral-0',
  prominence: 'lf:bg-prominence-500 lf:text-neutral-0',
};

export const Badge: FC<BadgeProps> = ({
  className,
  as: Element = 'div',
  children,
  size,
  type = 'neutral',
  ...rest
}) => {
  return (
    <Element
      {...rest}
      className={cn(
        'lf:flex lf:items-center lf:justify-center lf:rounded-full',
        sizeMap[size],
        typeMap[type],
        className,
      )}
    >
      {children}
    </Element>
  );
};
